// Content for the CE cross-sell card displayed on the My Plan page.
// Do not display covered items count or gaps in coverage on this card.
export const MY_PLAN_CE_CROSS_SELL_CONTENT = {
  title: `Your electronics aren't covered`,
  description: `Your current plan doesn't include consumer electronics. Add coverage for the devices your household uses every day.`,
  devicesLabel: 'Eligible devices',
  buttonLabel: 'Add coverage',
  devices: [
    { label: 'TVs', icon: 'assets/icons/ce-device-tv.svg' },
    { label: 'Laptops', icon: 'assets/icons/ce-device-laptop.svg' },
    { label: 'Tablets', icon: 'assets/icons/ce-device-tablet.svg' },
    { label: 'Gaming consoles', icon: 'assets/icons/ce-device-gamepad.svg' },
    { label: 'Printers', icon: 'assets/icons/ce-device-print.svg' },
  ],
};
